import cn from 'clsx';
import Image from 'next/image';

import s from './LookUpRequestView.module.scss';

import IllustQuotes from '@/assets/illust-icons/ic_quotes.svg';

interface Props {
  cardIndex: number;
  isShow: boolean;
}
type ReviewCardProps = Props;

const ReviewCard = ({ cardIndex, isShow }: ReviewCardProps) => {
  const cards = [
    {
      color: 'blue',
      comment: '처음에는 사기는 아닐까 걱정했는데요. 아무 문제없이 1,200만원 환급받았습니다.',
      personalTitle: '총 12,274,023원 환급완료',
      personalDescription: '곽지영 대표님 | 개인·법인사업자'
    },
    {
      color: 'cyan',
      comment: '네이버 투자사라 믿고 신청했어요. 다음번에도 신청할 생각입니다.',
      personalTitle: '총 11,029,935원 환급완료',
      personalDescription: '김명원 대표님 | 개인사업자'
    },
    {
      color: 'olive',
      comment: '주변에 사업하는 분들 그 누구라도 추천하고 싶습니다.',
      personalTitle: '총 4,679,608원 환급완료',
      personalDescription: '박종호 대표님 | 개인·법인사업자'
    },
    {
      color: 'pink',
      comment: '소상공인 세금 관리, 절세만 있는 게 아니더라고요!',
      personalTitle: '총 20,414,970원 환급완료',
      personalDescription: '이상훈 대표님 | 개인사업자'
    },
    {
      color: 'cornflower',
      comment: '언제 어디서나 휴대폰 하나로 환급금 조회도 쉽고 편리한 게 매력적으로 느껴졌습니다.',
      personalTitle: '대기업 1타 강사',
      personalDescription: '이광희 대표님 | 개인사업자'
    },
    {
      color: 'orange',
      comment: '이전에 환급받은 것도 꽤 컸었는데 신규 환급금이 매년 발생하더라고요.',
      personalTitle: '미슐랭 2스타',
      personalDescription: '선우홍희 쉐프님 | 법인사업자'
    },
    {
      color: 'green',
      comment: '예상 환급금과 실제 환급금이 거의 유사하다는 부분에서 신뢰가 갔습니다.',
      personalTitle: '서울대 졸업 치과 원장',
      personalDescription: '서준석 원장님 | 개인사업자'
    }
  ];

  return (
    <div
      className={cn('absolute flex w-full rounded-[20px] bg-gray-50', {
        [`${s.fade_in_up}`]: isShow,
        [`${s.fade_out}`]: !isShow
      })}
    >
      <div className={cn('flex w-full flex-col p-5', s[`${cards[cardIndex]?.color}`])}>
        <IllustQuotes className={s.review_quotes_icon} />
        <div className="sub-title-16 mb-4 mt-3 text-gray-800">{cards[cardIndex]?.comment}</div>
        <div className="flex gap-4">
          <div className={cn('flex h-[56px] w-[56px] items-center justify-center gap-2.5 rounded-[40px] border-2 bg-white', s.review_image_border)}>
            <Image
              className="rounded-full"
              src={`/images/incomeTaxRefund/reviewers/img_card-review${cardIndex + 1}.png`}
              width={48}
              height={48}
              alt={cards[cardIndex]?.personalDescription ?? ''}
            />
          </div>
          <div className="flex flex-col justify-center">
            <div className="sub-title-15 text-gray-800">{cards[cardIndex]?.personalTitle}</div>
            <div className="text-[12px] text-gray-600">{cards[cardIndex]?.personalDescription}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
